import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SvgSourceDirective } from './svg-source.directive';

@NgModule({
  declarations: [SvgSourceDirective],
  exports: [SvgSourceDirective],
  imports: [CommonModule],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class SvgSourceModule {}
